import { FC, useEffect } from 'react'

import { Link, useParams, useNavigate } from 'react-router-dom'
import { message } from 'antd'
import styled, { useTheme } from 'styled-components'

import { FullWideNotification } from 'src/Components/FullWideNotification'
import { resetPassword } from 'src/Redux/auth-process/emailPasswordSlice/api-actions'
import { useAppDispatch } from 'src/Hooks/redux'
import { pageInfo } from 'src/Helpers/TagManager/pageInfo'
import { locationEvent, pageViewEvent } from 'src/Helpers/TagManager'
import { variables } from 'src/Styled/variables'

import ForgotPasswordForm from './components/ResetPasswordForm'

import { Logo, TextCenter, Wrapper } from './styles'

const logo = '/logo.png'
const DELAY_3000 = 3000

const Container = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 600px;
  width: 100%;
  padding: 32px;
  align-items: center;
  gap: 24px;
  border-radius: 16px;
  border: 1px solid ${({ theme }) => theme.color.lightGrey};
  background: ${({ theme }) => theme.color.white};
  box-shadow: ${({ theme }) => theme.shadow.card};
`

const Header = styled.div`
  color: ${({ theme }) => theme.color.darkGrey};
  text-align: center;
  font-family: Segoe UI;
  font-size: ${variables.fontSize24};
  font-style: normal;
  font-weight: ${variables.fontWeight600};
  line-height: 150%;
`

const LoginContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  max-width: 600px;
  width: 100%;
`

const ResetPassword: FC = () => {
  const navigate = useNavigate()
  const theme = useTheme()
  const [messageApi, contextHolder] = message.useMessage()
  const dispatch = useAppDispatch()

  useEffect(() => {
    pageViewEvent({ currentPageInfo: pageInfo.resetPassword })
    locationEvent()
  }, [])

  const { uuid } = useParams<{ uuid?: string }>()

  const handleSubmit = (formStates: {
    password: string
    confirm: string
  }): void => {
    const { password } = formStates
    if (password && uuid) {
      void dispatch(resetPassword({ password, uuid }))
        .unwrap()
        .then((res) => {
          void messageApi.open({
            content: (
              <FullWideNotification message='Your password has been changed.' />
            ),
            duration: 3,
            style: { backgroundColor: theme.color.brandGreen },
          })
          return res
        })
        .catch(() => {
          void messageApi.open({
            content: (
              <FullWideNotification message='Your reset link expired after 24 hours or has already been used.' />
            ),
            duration: 3,
            style: { backgroundColor: theme.color.mediumRed },
          })
        })
        .finally(() => {
          setTimeout(() => {
            navigate('/')
          }, DELAY_3000)
        })
    }
  }

  return (
    <Wrapper>
      {contextHolder}
      <LoginContainer>
        <Logo>
          <img width={236} height={52} alt='logo' src={logo} />
        </Logo>

        <Container>
          <Header>Reset Password</Header>
          <ForgotPasswordForm onSubmit={handleSubmit} />
          <TextCenter>
            <Link to='/'>Back to Login</Link>
          </TextCenter>
        </Container>
      </LoginContainer>
    </Wrapper>
  )
}

export default ResetPassword
